import { render, staticRenderFns } from "./CourseActivation.vue?vue&type=template&id=cc94895a&scoped=true&"
import script from "./CourseActivation.vue?vue&type=script&lang=js&"
export * from "./CourseActivation.vue?vue&type=script&lang=js&"
import style0 from "./CourseActivation.vue?vue&type=style&index=0&id=cc94895a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc94895a",
  null
  
)

export default component.exports